import React__default from 'react';
import classnames from 'classnames';
import { Tooltip } from '@grandvisionhq/common';

const DeliveryIndicatorTooltip = ({ message , view  })=>/*#__PURE__*/ React__default.createElement(Tooltip, {
        id: "delivery-tooltip",
        className: classnames(`delivery-indicator-tooltip--${view}`),
        message: message
    })
;

export { DeliveryIndicatorTooltip };
//# sourceMappingURL=DeliveryIndicatorTooltip.js.map
